import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppointmentsService } from '../../../../services/appointments/appointments.service.js';
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTabsModule } from '@angular/material/tabs';

/** The survey answer page */
@Component({
	selector: 'app-appointment-codes',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTooltipModule,
		MatTabsModule
	],
	templateUrl: './appointment-codes.component.html',
	styleUrl: './appointment-codes.component.scss'
})
export class AppointmentCodesComponent implements OnInit, OnDestroy {

	constructor(private appointmentsService: AppointmentsService) {

	}

	getContent() {
		return JSON.stringify(this.appointmentsService.appointmentDetail.codes??"",undefined,4).trim()
	}

	ngOnInit() {
	}

	ngOnDestroy() {
	}
}
